import { css, Global } from '@emotion/core';

function AppGlobalStyles() {
  return (
    <Global
      styles={css`
        @font-face {
          font-family: SpoqaNumbers;
          src:
            url(https://cdn.modusign.co.kr/service/font/SpoqaHanSansRegular-numbers-subset.woff2)
              format('woff2'),
            url(https://cdn.modusign.co.kr/service/font/SpoqaHanSansRegular-numbers-subset.woff)
              format('woff'),
            url(https://cdn.modusign.co.kr/service/font/SpoqaHanSansRegular-numbers-subset.ttf)
              format('ttf');
          unicode-range: U+0030-0039;
        }
      `}
    />
  );
}

export default AppGlobalStyles;
